export default function datepickerPopupConfig(uibDatepickerPopupConfig) {
	uibDatepickerPopupConfig.onOpenFocus = false;
}